;(function () {
  'use strict'

  angular
    .module('contrast.modal-rotate-key')
    .factory('rotateKeyModalService', rotateKeyModalService)

  function rotateKeyModalService($uibModal, $translate) {
    'ngInject'

    var service = {
      openRotateKeyModal: openRotateKeyModal
    }

    return service

    function openRotateKeyModal(keyType) {
      return $uibModal.open({
        templateUrl: 'components/modal-rotate-key/modal_rotate_api_keys.html',
        controller: 'RotateKeyModalCtrl',
        controllerAs: 'ctrl',
        size: 'md-sm',
        windowClass: 'modal-rotate-key',
        resolve: {
          title: function () {
            return $translate.instant('title_warning')
          },
          keyType: function () {
            return keyType
          }
        }
      }).result
    }
  }
})()
